export default __webpack_public_path__ + "media/images/close-1bf65bc11eea13f2a83b7aca3f82acf6.svg";